import { render, staticRenderFns } from "./preliminary_raceManagement.vue?vue&type=template&id=10a84304&scoped=true&"
import script from "./preliminary_raceManagement.vue?vue&type=script&lang=js&"
export * from "./preliminary_raceManagement.vue?vue&type=script&lang=js&"
import style0 from "./preliminary_raceManagement.vue?vue&type=style&index=0&id=10a84304&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a84304",
  null
  
)

export default component.exports